/**
 * <StageProgramSkeleton> — la forme du programme d'un stage pendant son premier chargement.
 *
 * Le haut (le stage, son titre, ses dates, le bouton « Adapter »), puis trois jours de deux
 * chapitres, chacun la forme d'une `<RevisionProgramCard>` : l'icône de la matière, le chapitre, son
 * heure. Une semaine de stage ordinaire.
 */
import React from "react"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../../molecules/Card"

/** Les chapitres de chaque jour montré. */
const DAYS = [2, 2, 2]

export function StageProgramSkeleton() {
    return (
        <Stack gap="6">
            <Stack gap="3">
                <Skeleton textSize="text-xs" width={110} />
                <Skeleton textSize="text-2xl" width="70%" />
                <Skeleton textSize="text-md" width={160} />
                <Skeleton shape="chip" width={240} />
            </Stack>
            {DAYS.map((chapters, day) => (
                <Stack key={day} gap="3">
                    <Skeleton textSize="text-lg" width={150} />
                    {Array.from({ length: chapters }, (_, index) => (
                        <Card key={index}>
                            <Row gap="3" align="center">
                                <Skeleton shape="block" width={40} height={40} />
                                <Stack gap="1">
                                    <Skeleton textSize="text-lg" width={180} />
                                    <Skeleton textSize="text-sm" width={90} />
                                </Stack>
                            </Row>
                        </Card>
                    ))}
                </Stack>
            ))}
        </Stack>
    )
}
